import { render, staticRenderFns } from "./internetError.vue?vue&type=template&id=45c1a33c&scoped=true"
import script from "./internetError.vue?vue&type=script&lang=js"
export * from "./internetError.vue?vue&type=script&lang=js"
import style0 from "./internetError.vue?vue&type=style&index=0&id=45c1a33c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1a33c",
  null
  
)

export default component.exports